<ng-container *ngIf="worksheets$ | async as worksheets; else loadingRef">
  <ng-container *ngIf="isGalleryPage">
    <ng-container *ngFor="let worksheetGroup of worksheets">
      <div class="py-lg-4 pb-3 bg-primary" [ngClass]="{ 'bg-kid': isKid }">
        <div class="container d-lg-flex gap-4 flex-column">
          <div class="first-video-container col-12" *ngIf="selectedVideo">
            <ng-container #outlet [ngTemplateOutlet]="content"></ng-container>
            <ng-template #content>
              <fgb-worksheet-item [worksheetItem]="selectedVideo" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
              <h4 class="text-white font-size-18 mt-3 mb-0 fw-bold text-uppercase">{{ selectedVideo.Title }}</h4>
              <p class="text-white font-size-14 mb-0">{{ selectedVideo.Description }}</p>
            </ng-template>
          </div>
          <div class="other-video-container">
            @if (listVideos && listVideos.length > 0) {
            <fgb-media-playlist
              [videos]="listVideos"
              (playlistSelect)="onVideoSelect($event)"
              [selectedIndex]="selectedIndex"
            ></fgb-media-playlist>
            }
          </div>
        </div>
      </div>
      <div class="container text-center" *ngIf="hasWorksheetType(worksheetGroup.Items, worksheetType.Gallery)">
        <div>
          <h2 class="text-start header-title text-uppercase my-3">{{ 'gallery.content.title' | translate }}</h2>
          <div class="row row-gap-20 pb-4">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Gallery">
                <div class="{{ colOverride }}" [ngClass]="isList && !colOverride ? 'col-lg-4 col-12' : ''">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isWorksheetPage">
    <ng-container *ngFor="let worksheetGroup of worksheets">
      <div class="container text-center mt-lg-4 pb-5">
        <div>
          <!-- <h2 class="font-size-18 text-start download-title text-capitalize text-white mt-0 pt-4">{{ 'downloads.title' | translate }}</h2> -->
          <div class="row row-gap-20">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Download">
                <div class="{{ colOverride }}" [ngClass]="isList && !colOverride ? 'col-lg-4 col-12' : ''">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
